module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.06c144f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi-dialog.png
// module id = felI
// module chunks = 0